export const deviceMixin = {
  data() {
    return {};
  },
  computed: {
    isMobileDevice() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      return isMobile;
    },

    isIOSDevice() {
      const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isMobile;
    },

    // isLandscape() {
    //   if (!this.isMobileDevice) return false;
    //   //console.log("isLandscape:", );
    //   if (window.innerWidth > window.innerHeight) return true;
    //   return false;
    // },

    deviceWidth() {
      //const clientWidth = this.isLandscape ? screen.height : screen.width;
      const clientWidth = screen.width;
      return clientWidth;
    },

    isMobileView() {
      return this.$store.state.mobileView;
    },
  },
};
